// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.choose-sync {
  min-height: calc(100vh - 140px);
  padding: 40px;
  background: #f8fafc;
}

.choose-sync-header {
  text-align: center;
  margin-bottom: 40px;
}

.choose-sync-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.choose-sync-header p {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 8px;
  line-height: 1.6;
}

.sync-options {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.sync-option-card {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  background: #ddd6fe;
  border-radius: 12px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid transparent;
}

.sync-option-card:hover {
  border-color: #8b5cf6;
}

.sync-option-card.selected {
  border-color: #8b5cf6;
  background: #c4b5fd;
}

.option-checkbox {
  flex-shrink: 0;
  margin-top: 4px;
}

.option-checkbox input {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #8b5cf6;
}

.option-icon {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  background: #1f2937;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.option-content {
  flex: 1 1;
}

.option-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.direction-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  flex-shrink: 0;
}

.direction-arrow.bidirectional {
  color: #059669;
}

.direction-arrow.unidirectional {
  color: #3b82f6;
}

.option-description {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.6;
}

.settings-note {
  text-align: center;
  margin-bottom: 40px;
}

.settings-note p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.actions-section {
  display: flex;
  justify-content: center;
  gap: 16px;
  max-width: 900px;
  margin: 0 auto;
}

.back-button,
.continue-button {
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button {
  background: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
}

.back-button:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

.continue-button {
  background: #3b82f6;
  color: white;
  border: 1px solid #3b82f6;
}

.continue-button:hover:not(:disabled) {
  background: #2563eb;
  border-color: #2563eb;
}

.continue-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #9ca3af;
  border-color: #9ca3af;
}

@media (max-width: 768px) {
  .choose-sync {
    padding: 20px;
  }

  .sync-option-card {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .option-title {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }

  .option-icon {
    align-self: center;
  }

  .actions-section {
    flex-direction: column;
  }

  .back-button,
  .continue-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector/components/ChooseSync.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".choose-sync {\n  min-height: calc(100vh - 140px);\n  padding: 40px;\n  background: #f8fafc;\n}\n\n.choose-sync-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.choose-sync-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 12px;\n}\n\n.choose-sync-header p {\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 8px;\n  line-height: 1.6;\n}\n\n.sync-options {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-bottom: 30px;\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.sync-option-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  background: #ddd6fe;\n  border-radius: 12px;\n  padding: 24px;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 2px solid transparent;\n}\n\n.sync-option-card:hover {\n  border-color: #8b5cf6;\n}\n\n.sync-option-card.selected {\n  border-color: #8b5cf6;\n  background: #c4b5fd;\n}\n\n.option-checkbox {\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n.option-checkbox input {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #8b5cf6;\n}\n\n.option-icon {\n  flex-shrink: 0;\n  width: 60px;\n  height: 60px;\n  background: #1f2937;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.option-content {\n  flex: 1;\n}\n\n.option-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.direction-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n.direction-arrow.bidirectional {\n  color: #059669;\n}\n\n.direction-arrow.unidirectional {\n  color: #3b82f6;\n}\n\n.option-description {\n  font-size: 14px;\n  color: #4b5563;\n  line-height: 1.6;\n}\n\n.settings-note {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.settings-note p {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n}\n\n.actions-section {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.back-button,\n.continue-button {\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.back-button {\n  background: white;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n}\n\n.back-button:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.continue-button {\n  background: #3b82f6;\n  color: white;\n  border: 1px solid #3b82f6;\n}\n\n.continue-button:hover:not(:disabled) {\n  background: #2563eb;\n  border-color: #2563eb;\n}\n\n.continue-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #9ca3af;\n  border-color: #9ca3af;\n}\n\n@media (max-width: 768px) {\n  .choose-sync {\n    padding: 20px;\n  }\n\n  .sync-option-card {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n  }\n\n  .option-title {\n    flex-direction: column;\n    gap: 8px;\n    text-align: center;\n  }\n\n  .option-icon {\n    align-self: center;\n  }\n\n  .actions-section {\n    flex-direction: column;\n  }\n\n  .back-button,\n  .continue-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
